<template>
  <form class="files column" onsubmit="return false;" @submit="submitFiles()">
    <div
      v-if="!showDrop"
      class="column drag grid-12 justify-center align-center"
      @drop.prevent="drop"
      @dragover.prevent
    >
      <div class="sub">
        <br />Você pode utilizar variavéis customizadas:
        <br />
        <code v-html="'{{nome_usuario}} ou {{primeiro_nome_usuario}}'" />
        <div class="field">
          <div
            class="filler row align-center"
            :style="`width: ${file.percentLoaded}%`"
          >
            {{ file.name || file.percentLoaded + "%" }}
          </div>
        </div>
      </div>
      Arraste e solte os arquivos de template.
      <div class="justify-center row">
        <Button
          layout="blue-m templateButton"
          onclick="document.getElementById('attach').click()"
          type="button"
        >
          <i class="fa fa-upload"></i> UPLOAD TEMPLATE
        </Button>
      </div>
    </div>
    <div v-else class="column">
      <div class="row">
        <div class="grid-5 column justify-center">
          {{ file.name || "Template" }}
        </div>
        <div class="grid-7 row justify-end">
          <Button
            layout="blue-m"
            onclick="document.getElementById('attach').click()"
            type="button"
          >
            <i class="fa fa-upload"></i> UPLOAD TEMPLATE
          </Button>
        </div>
      </div>

      <div class="row template">
        <iframe id="template" />
      </div>
    </div>
    <input
      id="attach"
      type="file"
      ref="files"
      @change="loadFile"
      class="hide"
    />
  </form>
</template>

<script>
import Button from "@/components/Button";
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "FileTemplate",
  components: {
    Button,
  },
  props: { showDrop: Boolean, templateRender: String },
  data() {
    return {
      file: { name: "", percentLoaded: 0 },
      files: [],
      loader: true,
      allow: false,
      template: "",
    };
  },
  beforeMount() {
    if (this.templateRender) this.loadTemplate(this.templateRender);
  },
  watch: {
    showDrop: function (val) {
      if (!val) {
        this.file = { name: "", percentLoaded: 0 };
        this.files = [];
        this.template = "";
        document.getElementById("attach").value = "";
      }
    },
  },
  methods: {
    ...mapMutations("general", ["SET_STATUS"]),
    ...mapActions("user", ["SET_FILES"]),
    loadFile(f) {
      if (this.$refs.files.files.length) {
        this.allow = false;
        this.files = this.$refs.files.files;
        var file;
        if (f.target) file = f.target.files;
        if (f.dataTransfer) file = f.dataTransfer.files;
        if (f[0]) {
          file = f;
          this.files = f;
        }
        file = file[0];

        if (file) {
          let reader = new FileReader();
          reader.readAsBinaryString(file);
          reader.onprogress = (e) => {
            if (e.lengthComputable)
              this.file.percentLoaded = Math.round((e.loaded / e.total) * 100);
          };

          reader.onload = (e) => {
            if (file.type === "text/html") {
              this.allow = true;
              this.$emit("changeDrop", true);
              this.file.name = file.name;
              var formData = new FormData();
              formData.append("arquivo", this.files[0]);
              this.$emit("file", formData);
              let render = decodeURIComponent(escape(e.target.result));

              render = render
                .replace(/\{\{ nome_usuario \}\}/g, this.user.nome)
                .replace(/\{\{nome_usuario\}\}/g, this.user.nome)
                .replace(
                  /\{\{ primeiro_nome_usuario \}\}/g,
                  this.user.primeiro_nome
                )
                .replace(
                  /\{\{primeiro_nome_usuario\}\}/g,
                  this.user.primeiro_nome
                );

              this.loadTemplate(render);
            } else {
              this.SET_STATUS({
                color: "red",
                text: "TIPO DE ARQUIVO NÃO PERMITIDO",
              });
            }
          };
        }
      }
    },
    loadTemplate(file) {
      setTimeout(function () {
        let iframe = document.getElementById("template").contentWindow.document;
        iframe.body.innerHTML = "";
        iframe.write(file);
      }, 500);
    },
    drop(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      this.loadFile(droppedFiles);
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.files {
  border-radius: 4px;
  padding: 0px 35px;
  background: $white;
  z-index: 9;

  .drag {
    margin-top: 25px;
    border: 3px dashed #cbcfd3;
    border-radius: 10px;
    height: 385px;
    background: #fafafa 0% 0% no-repeat padding-box;
  }
  .templateButton {
    margin-top: 40px;
  }
  strong {
    font-weight: 500;
    color: $gray-1;
  }
  .sub {
    margin-top: 25px;
    color: $gray-1;
    text-align: center;
    margin-top: 30px;
    em {
      font-size: 11px;
      margin-top: 18px;
    }
  }

  .filler {
    background: $green-8;
    height: 12px;
    padding-left: 10px;
    color: $gray-4;
    font-size: 12px;

    font-weight: bold;
  }
  .field {
    margin-top: 40px;
    height: 12px;
    background: #f2f2f2 0% 0% no-repeat padding-box;
    border: 1px solid #dbdbdb;
    border-radius: 10px;
    overflow: hidden;
    opacity: 1;
  }
  .template {
    background: #f4f4f4;
    border-radius: 10px;
    margin-top: 10px;
    font-size: 15px;
    height: 370px;
    overflow: auto;
    iframe {
      border: none;
      width: 100%;
      height: 100%;
    }
  }
}
</style>